export const delay = (ms: number) => {
  return new Promise(resolve => {
    const timeout = setTimeout(() => {
      resolve({});
      clearTimeout(timeout);
    }, ms);
  });
};
